import {ReportAssetsModel} from "../../models/reports/ReportAssetsModel";

export class ReportAssetsCtrl {
    public static $inject = ['$scope','ReportAssetsModel'];
    constructor(public $scope:any, public model:ReportAssetsModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.name, this.model.location, this.model.locationSite, this.model.tagType, this.model.assetType, this.model.department, this.model.disposalStatus, this.model.checkedinStatus, this.model.missing], (newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
